const initialState = {
  data: null,
};

const PolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Send_SchemeID_From": {
      return { ...state, data: action.value };
    }

    default: {
      return state;
    }
  }
};

export default PolicyReducer;
